import React from 'react';
import {Box, Step, StepContent, StepLabel, Stepper, Typography} from "@mui/material";
import {StepWrapperProps} from "@/components/forms/Stepper/Linear/types";

export const LinearStepper = (props: StepWrapperProps): any => {
    const {activeStep, steps, finishComponent, orientation, nonLinear} = props;

    const totalSteps = () => {
        return steps.length;
    };

    return (
        <Box sx={{width: '100%'}}>
            <Stepper nonLinear={nonLinear} activeStep={activeStep} orientation={orientation}>
                {
                    steps.map(({label, component}, index) => {
                        return (
                            <Step key={label}>
                                <StepLabel
                                    optional={
                                        index === (totalSteps() - 1) ? (
                                            <Typography variant="caption">Last step</Typography>
                                        ) : null
                                    }
                                >
                                    {label}
                                </StepLabel>
                                {
                                    orientation === "vertical" &&
                                    <StepContent>
                                        {component}
                                    </StepContent>
                                }
                            </Step>
                        )
                    })
                }
            </Stepper>

            {
                orientation === "horizontal" &&
                <Box sx={{width: '100%'}}>
                    {
                        activeStep === totalSteps() ? finishComponent : steps[activeStep].component
                    }
                </Box>
            }

            {
                (orientation === "vertical" && activeStep === totalSteps()) &&
                <Box sx={{width: '100%'}}>
                    {finishComponent}
                </Box>
            }
        </Box>
    )
}

export default LinearStepper;
